<template>
  <div style="padding-top: 65px; box-sizing: border-box; font-size: 0.35rem">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <h4 class="header-title">安全中心</h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
      </div>
    </div>
    <van-swipe :show-indicators="false">
      <van-swipe-item>
        <img src="/static/image/banner_022.jpg" style="width: 100%" alt="" />
      </van-swipe-item>
      <van-swipe-item>
        <img src="/static/image/banner_011.jpg" style="width: 100%" alt="" />
      </van-swipe-item>
    </van-swipe>
    <div class="securityCenter">
      <div class="container">
        <div class="row clearfix" style="padding-bottom: 0px">
          <div style="display: flex">
            <a id="accProtection_btn" :class="type == 1 ? 'col-xs-4 dj-1 bkd-2' : 'col-xs-4 dj-1 bkd-1'" @click="type = 1">
              <span>账号保护</span>
            </a>
            <a id="antiFraudCase_btn" :class="type == 2 ? 'col-xs-4 dj-2 bkd-2' : 'col-xs-4 dj-2 bkd-1'" @click="type = 2">
              <span>防骗案例</span>
            </a>
            <a id="securityTopic_btn" :class="type == 3 ? 'col-xs-4 dj-3 bkd-2' : 'col-xs-4 dj-3 bkd-1'" @click="type = 3">
              <span>安全专题</span>
            </a>
          </div>

          <br />
          <div class="my-main row" style="display: block; box-sizing: border-box; padding: 0 15px" v-if="type == 1">
            <div class="big-img col-xs-12" style="padding-left: 0px; padding-right: 0px; display: block">
              <div class="mybg-1">
                <img src="/static/image/web-bank.png" class="btn-1" style="display: block" />
                <img src="/static/image/web-wanbo.png" class="btn-2" style="display: none" />
              </div>
            </div>

            <div class="aqzt col-xs-12" style="margin-top: 20px">
              <div class="mybg-2 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-2">2. 账号保护须知：</p>
              </div>
              <div class="myfont myfont-2 col-xs-12">建议用户在注册成为ManBetX万博的会员之后即刻验证自己的手机号码与邮箱，提升账号安全等级，同时完成验证有助于提高您的存取款效率。</div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-3 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-3">3. 信息保护须知：</p>
              </div>
              <div class="myfont myfont-3 col-xs-12">
                ManBetX万博会严格保护用户的账户信息安全，我们将使用高科技系统管理和保护客户个人信息数据，并且每一项数据都会在云端中加密保护，只有 使用客户独一无二的用户名和密码才可进入该客户账户，客户信息数据储存在安控服务器内，其它账户无法查看到您的身份信息。
                确保用户隐私安全，是我们的准则，也是底线。 同时，也请您在享受游戏乐趣的同时，不要随意向他人泄露个人隐私信息。
              </div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-4 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-4">4. 投注保护须知：</p>
              </div>
              <div class="myfont myfont-4 col-xs-12">在ManBetX万博投注游戏时，请注意您的网络情况是否稳定，如果在网络不稳定的情况下极有可能会发生投注无法成功确认的情况。</div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-5 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-5">5. 登录保护须知：</p>
              </div>
              <div class="myfont myfont-5 col-xs-12">建议用户提高警惕，在键入账号密码时请勿随意访问各类可疑网址，尤其是不知名的小网站很可能含有木马以盗取您的账号密码，同时，请勿在 ManBetX万博官网之外的任何网站输入您的账号和密码。</div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-6 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-6">6. 存款保护须知：</p>
              </div>
              <div class="myfont myfont-6 col-xs-12">ManBetX万博致力于为用户提供优质及安全快捷的存款支付服务，为确保用户的账户资金更加安全、交易更加可靠，在ManBetX万博进行交易时， 请不要打开其它可疑网站，同时遵循存款提示进行操作，以免意外情况的发生。</div>
            </div>
            <div class="col-xs-12 mytop">
              <div class="mybg-7 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-7">7. 取款保护须知：</p>
              </div>
              <div class="myfont myfont-7 col-xs-12">请您在取款时，确认您的取款银行卡是否可用，同时确认您的银行卡各项信息，如：持卡人姓名，银行卡号，银行名称等是否正确，从而保障您的取 款安全与取款效率。</div>
            </div>

            <div class="col-xs-12 mytop mynone" style="display: none">
              <div class="mybg-8 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-8">7.弱口令安全须知：</p>
              </div>
              <div class="myfont myfont-8 col-xs-12">
                相信很多客户在自己常用的网站，普遍都会有一个使用默认密码的习惯，其实这很容易给您的账号安全带来隐患。因此，ManBetX万博建议您密码设置一定要复杂，而且要定期修改，很多时候我们虽然不能阻止黑客攻击，但是可以通过增加黑客破解时间和攻击成本，以此争取到更多变动时间来保护我们的账号安全。
              </div>
            </div>
          </div>
          <div class="my-main row" style="display: block; box-sizing: border-box; padding: 0 15px" v-if="type == 2">
            <div class="big-img col-xs-12" style="padding-left: 0px; padding-right: 0px; display: block">
              <div class="mybg-1">
                <img src="/static/image/web-bank.png" class="btn-1" style="display: none" />
                <img src="/static/image/web-wanbo.png" class="btn-2" style="display: block" />
              </div>
            </div>

            <div class="aqzt col-xs-12">
              <div class="mybg-2 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-2">2. 防骗安全须知：</p>
              </div>
              <div class="myfont myfont-2 col-xs-12">ManBetX万博的工作人员在任何情况下都不会向用户索取密码，谨记密码不要随意提供给任何人。</div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-3 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-3">3. 客户端防伪须知：</p>
              </div>
              <div class="myfont myfont-3 col-xs-12">ManBetX万博旗下两款移动客户端——万博全站客户端、万博体育客户端均可在官网客户端页面中下载，请仔细甄别客户端下载源与产品功能区别，如全站客户端有赛事视频直播入口、体育客户端的动画直播与投注页面同框等，以此即可甄别客户端真假。</div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-4 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-4">4. 线下防骗须知：</p>
              </div>
              <div class="myfont myfont-4 col-xs-12">
                ManBetX万博是一个享有亚洲在线体育综合娱乐领导品牌声誉的投注机构，绝无任何线下服务与任何线下操作。诈骗者通常会利用玩家心里，再结合黑科技手段盗取到您的个人信息，用一些概括性的语言描述您的相关情况，引起您的紧张感或兴趣。如若有短信/邮件冒充万博机构，请勿相信短信/邮件内容，更勿点击短信/邮件链接；如若有私人冒充万博客服联系到您，请勿相信，更勿透露任何账户信息与密码，任何离开万博官网的对话内容都不受到保护，务必随时保持警惕。
              </div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-5 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-5">5. 存款防骗须知：</p>
              </div>
              <div class="myfont myfont-5 col-xs-12">
                ManBetX万博采用了目前先进的加密技术和防火墙系统保护您的安全、隐私，并以国际顶级银行及支付机构为标准合作40多家主流银行机构，以保证客户享受公平公正的待遇，为您的财务安全保驾护航。我们绝对没有开放任何线下收款或者代收款等服务窗口，请您务必选择我们的官方入口进行存款操作，切勿相信任何非官方平台的套路用语，轻易将自己的款项交由他们。
              </div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-6 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-6">6. 假冒客服诈骗须知：</p>
              </div>
              <div class="myfont myfont-6 col-xs-12">
                ManBetX万博在线客服提供365天7X24小时全天候的服务，只为给客户最好的服务，目前只开放了“文字客服”和“电话客服”这两种服务形式，暂时还未开放视频客服服务。我们绝对没有开放任何客服直接或者代收款服务，任何非ManBetX万博官方入口提供的客服不正常引导或者直接收款服务都不受保护，请您务必对此保持警惕态度。
              </div>
            </div>
            <div class="col-xs-12 mytop">
              <div class="mybg-7 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-7">7. 电话邮件钓鱼诈骗须知：</p>
              </div>
              <div class="myfont myfont-7 col-xs-12">
                ManBetX万博官方联系方式，均有发布在官方网站底部的【关于万博】分栏【关于我们】中的【联系方式】，在这里客户可以将所有受网站保护的客服联系方式一览无遗，除此之外的任何电话和邮件均不归ManBetX万博所有。如您在日常生活中，收到任何处心积虑向您索取账号、密码及资金的电话或邮件，请您务必在官方联系通道确认后再进行下一步操作。
              </div>
            </div>

            <div class="col-xs-12 mytop mynone" style="display: none">
              <div class="mybg-8 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-8"></p>
              </div>
              <div class="myfont myfont-8 col-xs-12"></div>
            </div>
          </div>
          <div class="my-main row" style="display: block; box-sizing: border-box; padding: 0 15px" v-if="type == 3">
            <div class="big-img col-xs-12" style="padding-left: 0px; padding-right: 0px; display: none">
              <div class="mybg-1">
                <img src="https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/security/web-bank.png" class="btn-1" style="display: none" />
                <img src="https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/security/web-wanbo.png" class="btn-2" style="display: block" />
              </div>
            </div>

            <div class="aqzt col-xs-12" style="margin-top: 20px">
              <div class="mybg-2 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-2">1.浏览器安全须知：</p>
              </div>
              <div class="myfont myfont-2 col-xs-12">
                <p>ManBetX万博建议您使用我们推荐的浏览器登录游戏，好的浏览器能提高您的游戏体验，并且让支付效率大大提升，我们积极与浏览器厂商合作，</p>
                <p>只为您可以享受优质游戏体验。</p>
                <p>建议您使用以下浏览器访问ManBetX万博：360浏览器/UC浏览器/搜狗浏览器/Microsoft Edge浏览器 /火狐Firefox浏览器/谷歌Chrome浏览器。</p>
              </div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-3 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-3">2.防劫持安全须知：</p>
              </div>
              <div class="myfont myfont-3 col-xs-12">
                <p>ManBetX万博向所有用户提供DNS防劫持插件，进入网站后可以在页面右下角点击下载。</p>
                什么是DNS劫持？
                <p>域名劫持是互联网攻击的一种方式，通过攻击域名解析服务器（DNS），或伪造域名解析服务器（DNS）的方法，把目标网站域名解析到错误的地</p>
                <p>址从而实现用户无法访问目标网站的目的。</p>
                <p>简单的说，就是您想来到ManBetX万博游戏，却被拉到了假网黑庄的手中，使用ManBetX万博的DNS防劫持插件，可以预防此类现象的发生。</p>
              </div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-4 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-4">3.咨询安全须知：</p>
              </div>
              <div class="myfont myfont-4 col-xs-12">ManBetX万博拥有7x24小时全天候在线客服为您服务，如有任何疑问，请直接咨询我们的官方客服，客服会为您提供专业帮助并协助跟进您处理完后续问题。</div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-5 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-5">4.个人安全须知：</p>
              </div>
              <div class="myfont myfont-5 col-xs-12">
                为保证您在ManBetX万博的唯一性与安全性，会员一经注册，不得再创建另外的账户。如发现同一会员注册多个账户(包括使用另外的姓名)，或者提供无效、伪造的资料或资料属于其他人(包括使用了不同的程序和图像编辑器修改文件资料)，万博有权取消该账户的所有投注。同时，万博有权冻结账户并无需返还存款。
              </div>
            </div>

            <div class="col-xs-12 mytop">
              <div class="mybg-6 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-6">5.KYC安全须知：</p>
              </div>
              <div class="myfont myfont-6 col-xs-12">了解客户（Know Your Customer，简称KYC）指的是尽职调查活动，ManBetX万博作为一家正规牌照持有公司，必须完成这种职责以便为您提供服务。KYC程序的需求是建立在确保会员遵守相关法例以及公平合法交易的基础上。</div>
            </div>
            <div class="col-xs-12 mytop">
              <div class="mybg-7 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-7">6.法律安全须知：</p>
              </div>
              <div class="myfont myfont-7 col-xs-12">
                在ManBetX万博注册和投注前，各用户有责任确保自己完全遵守自身所在的地区、国家、省、州、县等相关法律。对在有关区域被视为非法活动的交易，万博将不会承担任何法律责任。万博保留权利随时修改更新安全须知，并展示于我们的官网上。您同意您有责任在使用万博产品前检查并了解所有内容。
              </div>
            </div>

            <div class="col-xs-12 mytop mynone" style="display: block">
              <div class="mybg-8 mybg" style="background-color: rgb(245, 245, 245)">
                <p class="my-p my-p-8">7.弱口令安全须知：</p>
              </div>
              <div class="myfont myfont-8 col-xs-12">
                相信很多客户在自己常用的网站，普遍都会有一个使用默认密码的习惯，其实这很容易给您的账号安全带来隐患。因此，ManBetX万博建议您密码设置一定要复杂，而且要定期修改，很多时候我们虽然不能阻止黑客攻击，但是可以通过增加黑客破解时间和攻击成本，以此争取到更多变动时间来保护我们的账号安全。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'securitycenter',
  data() {
    return { type: 1 };
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
/* Security */
.securityCenter {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
  background: #f2f3f4;
}
.securityCenter * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.securityCenter p {
  margin: 0 0 10px;
}
.swiper-container {
  width: 100%;
  height: 400px;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #46b8da;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.col-xs-4 {
  font-size: 20px;
  height: 82px;
  line-height: 82px;
  text-align: center;
  color: #333;
  cursor: pointer;
  border-radius: 3px;
  border: 1px solid #efefef;
}
.col-sm-4 {
  font-size: 20px;
  height: 82px;
  line-height: 82px;
  text-align: center;
  color: #333;
  cursor: pointer;
  border-radius: 3px;
  border: 1px solid #efefef;
}
.bkd-2 {
  background-color: #222;
  color: #fcf8e3;
}
.bkd-2:hover,
.bkd-2:active {
  color: #fff;
}
.mybg-1 {
  background: url('/static/image/btn-bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 2rem;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
  line-height: 2rem;
  font-size: 12px;
  padding-top: 0.6rem;
}
.mybg-1 img {
  width: 40%;
  height: auto;
  margin: 0 auto;
  display: block;
}
.mybg {
  background-color: #f5f5f5;
  margin: 0 auto;
  color: #333;
  font-size: 18px;
  padding: 18px 0;
  cursor: pointer;
}
.mynone {
  display: none;
}
.mytop {
  margin-top: 15px;
}
.switch {
  background-color: #666666;
}
.my-p {
  float: left;
  margin-left: 10px;
}
.icon-font {
  float: right;
  width: 80px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.icon-font span {
  margin-right: 10px;
}
.myfont {
  padding: 30px 45px;
  text-align: justify;
  font-size: 17px;
  margin: 0 auto;
  line-height: 30px;
}
.myfont span {
  color: red;
}
.my-main {
  display: none;
  margin-left: 0px;
  margin-right: 0px;
}
.mybg-zhbh-1 {
  display: block;
}
.manhua {
  max-width: 100%;
  height: auto;
}
.my-zhbh {
  margin-left: 0px;
  margin-right: 0px;
  padding-bottom: 1.5rem;
}
.mymh-1 {
  padding-left: 10px;
  padding-right: 0px;
}
.mymh-2 {
  padding-left: 0px;
  padding-right: 10px;
}
.mybg-zhbh-1 {
  background: url('/static/image/protect-bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 55px;
  line-height: 65px;
  margin: 0 auto;
  cursor: pointer;
  font-size: 14px;
  color: #eeeeee;
}
.mybg-zhbh-1 p {
  float: left;
  padding: 0px 18px;
}
.return {
  float: right;
  padding-right: 15px;
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: 16px;
}
.return span {
  margin-right: 5px;
  margin-top: 2px;
}
.comic {
  width: 100%;
  text-align: center;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 70px;
}
.comic img {
  max-width: 100%;
}
.foot-zhbh {
  width: 100%;
  height: 100%;
  padding: 0px 15px;
  text-align: justify;
  font-size: 14px;
  line-height: 26px;
  color: #222;
}
.my-fpal {
  display: none;
  margin-right: 0px;
  margin-left: 0px;
}
.mybg-fpal-1 {
  background: url('/static/image/protect-bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 55px;
  text-align: center;
  line-height: 65px;
  margin: 0 auto;
  cursor: pointer;
  font-size: 13px;
  color: #eeeeee;
}
.t1 {
  text-align: center;
  padding-top: 10px;
}
.t1 p {
  margin: 0 auto;
  color: #ffc171;
  font-size: 16px;
}
.t1 span {
  width: 100%;
  height: 100%;
  font-size: 17px;
  color: #ffc171;
  text-align: center;
}
.biao-0 {
  max-width: 100%;
  height: auto;
}
.biao-gap {
  margin: 10px auto;
}
.logo {
  text-align: center;
  padding-top: 10px;
}
.logo .biao {
  width: 140px;
  max-width: 100%;
  height: auto;
}
.t1 .biao-1 {
  width: 140px;
  max-width: 100%;
  height: auto;
}
.foot {
  padding-top: 10px;
}
.mybg-fpal-1 p {
  float: left;
  padding: 0px 18px;
}
.return-2 {
  float: right;
  padding-right: 15px;
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: 16px;
}
.return-2 span {
  margin-right: 5px;
  margin-top: 2px;
}
.new-bg {
  background: url('/static/image/new-bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  color: rgba(255, 255, 255, 0.7);
  padding-bottom: 1.2rem !important;
}
.bottom-border {
  position: fixed;
  width: 100%;
  bottom: 1.8rem;
}
.bottom {
  margin: 0 auto;
  background-color: #ffa061;
  height: 40px;
  width: 150px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  color: #eee;
  font-size: 18px;
  opacity: 0.8;
}
@media (max-width: 768px) {
  .col-sm-4 {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
  .col-xs-4 {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    width: 33.333333%;
    display: block;
  }
  .mybg {
    font-size: 13px;
    text-align: center;
    min-height: 50px;
    line-height: 100%;
  }
  .myfont {
    font-size: 13px;
    padding: 10px 20px;
    line-height: 20px;
  }
  .foot {
    font-size: 14px;
    padding: 10px 30px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/securitycenter.vue